/* eslint-disable import/prefer-default-export */
import CleanLayout from "./layouts/clean.svelte";
import { pages } from "./config";

export const routes = [
  { path: pages.account.url, component: "AccountList", layout: CleanLayout },
  {
    path: pages.account.list.url,
    component: "AccountList",
    layout: CleanLayout,
  },
  { path: pages.auth.logout.url, component: "LogoutPage", layout: CleanLayout },
  {
    path: pages.chargeups.url,
    component: "ChargeupIndex",
    layout: CleanLayout,
    siteTitle: "Webforma Account Chargeup",
  },
  {
    path: pages.chargeups.success.url,
    component: "ChargeupSuccess",
    layout: CleanLayout,
  },
  {
    path: pages.components.url,
    component: "ComponentsIndex",
    layout: CleanLayout,
    siteTitle: "Components",
  },
  {
    path: `${pages.components.url}/:slc`,
    component: "ComponentsIndex",
    layout: CleanLayout,
    siteTitle: "Components",
  },
  {
    path: `${pages.components.url}/:slc/:flc`,
    component: "ComponentsIndex",
    layout: CleanLayout,
    siteTitle: "Components",
  },
  {
    path: pages.dashboard.dashboard.url,
    component: "AccountDashboard",
    layout: CleanLayout,
    protected: false,
  },
  {
    path: pages.dashboard.url,
    component: "AccountDashboard",
    layout: CleanLayout,
    protected: false,
  },
  { path: pages.entry.url, component: "EntryPage", layout: CleanLayout },
  {
    path: pages.entry.link.url,
    component: "EntryLinkPage",
    layout: CleanLayout,
    siteTitle: "Turn your Guest Account into a Real Webforma Account",
  },
  {
    path: pages.entry.waiting.url,
    component: "EntryWaitingPage",
    layout: CleanLayout,
  },
  {
    path: pages.entry.welcome.url,
    component: "EntryWelcomePage",
    layout: CleanLayout,
  },
  {
    path: pages.entry.verify.url,
    component: "EntryVerifyPage",
    layout: CleanLayout,
  },
  {
    path: pages.entry.link.verify.url,
    component: "EntryVerifyPage",
    layout: CleanLayout,
  },
  {
    path: `${pages.forms.overview.url}/:fid`,
    component: "FormOverview",
    layout: CleanLayout,
    siteTitle: "Form Overview",
  },
  {
    path: `${pages.forms.add.url}`,
    component: "FormsAdd",
    layout: CleanLayout,
    siteTitle: "Add a Form",
  },
  {
    path: `${pages.forms.add.url}/:sid`,
    component: "FormsAdd",
    layout: CleanLayout,
    siteTitle: "Add a Form",
  },
  {
    path: `${pages.forms.delete.url}/:fid`,
    component: "FormsDelete",
    layout: CleanLayout,
    siteTitle: "Delete a Form",
  },
  {
    path: `${pages.forms.edit.url}/:fid`,
    component: "FormsEdit",
    layout: CleanLayout,
    siteTitle: "Edit a Form",
  },
  {
    path: `${pages.sites.delete.url}/:sid`,
    component: "SitesDelete",
    layout: CleanLayout,
    siteTitle: "Delete a Site from your Webforma Account",
  },
  {
    path: pages.sites.add.url,
    component: "SitesAdd",
    layout: CleanLayout,
    siteTitle: "Add a Site to your Webforma Account",
  },
  {
    path: `${pages.sites.edit.url}/:sid`,
    component: "SitesEdit",
    layout: CleanLayout,
    siteTitle: "Edit a Site",
  },
  {
    path: `${pages.sites.overview.url}/:sid`,
    component: "SiteOverview",
    layout: CleanLayout,
    siteTitle: "Website Overview",
  },
  {
    path: pages.sites.first.url,
    component: "SitesAddFirst",
    layout: CleanLayout,
    siteTitle: "Add your first site to Webforma",
  },
  {
    path: "*",
    component: "Error404",
    layout: CleanLayout,
    siteTitle: "Page not found",
  },
];
